import React from 'react';

import DataModelView from '../../common/view/DataModelView';

export default class UniformDailySummaryView extends DataModelView {
  getIntegratedPropertyNames() {
    return [];
  }

  render() {
    return (<div />);
  }
}